"use strict";

import {templates} from "Subschema";
import BtnConfirmTemplateLess from './BtnConfirmTemplate.less';
export default {
    'template': templates.FieldSetTemplate,
    'className': BtnConfirmTemplateLess.container
};



/** WEBPACK FOOTER **
 ** ./src/templates/BtnConfirmTemplate.jsx
 **/